import { useId } from "react";
function useCssId() {
  return useId().replaceAll(":", "");
}
export {
  useCssId
};
//# sourceMappingURL=use-css-id.js.map